import { DeepMap, FieldError, useForm, UseFormMethods } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import {
  RfpLaneCarrierRateCreateRequest,
  RfpLaneCarrierRateUpdateRequest,
} from 'apps/marketplace/apiTypes/requestForProposalLaneCarrierRates'
import { AddRateCardSchema, EditRateCardSchema } from 'apps/marketplace/schema/RateCardSchema'
import { IRFPLaneRate } from '../api/rfpLaneRates'

export interface RateFormErrors
  extends DeepMap<RfpLaneCarrierRateCreateRequest['rfpLaneCarrierRate'], FieldError> {}

interface RFPLaneRateFormProps {
  rfpLaneRate?: IRFPLaneRate
}

export const useRFPLaneCreateRateForm = ({
  rfpLaneRate,
}: RFPLaneRateFormProps): UseFormMethods<RfpLaneCarrierRateCreateRequest['rfpLaneCarrierRate']> => {
  const { canDoWeekends = false, carrierApplication, confirmed = false, rate } = rfpLaneRate || {}
  const { amount = '', rateTypeKey = '' } = rate || {}
  const { id: carrierApplicationId = '' } = carrierApplication || {}

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(AddRateCardSchema),
    defaultValues: {
      ...AddRateCardSchema.cast({
        carrierApplicationId,
        rateAttributes: {
          amount,
          rateTypeKey,
        },
        canDoWeekends,
        confirmed,
      }),
    },
  })

  return methods
}

export const useRFPLaneEditRateForm = ({
  rfpLaneRate,
}: RFPLaneRateFormProps): UseFormMethods<RfpLaneCarrierRateUpdateRequest['rfpLaneCarrierRate']> => {
  const {
    canDoWeekends = false,
    carrierApplication,
    confirmed = false,
    maxCapacity = null,
    minCapacity = null,
    rate,
  } = rfpLaneRate || {}
  const { amount = '', rateTypeKey = '' } = rate || {}
  const { id: carrierApplicationId = '' } = carrierApplication || {}

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(EditRateCardSchema),
    defaultValues: {
      ...EditRateCardSchema.cast({
        carrierApplicationId,
        rateAttributes: {
          amount,
          rateTypeKey,
        },
        minCapacity,
        maxCapacity,
        canDoWeekends,
        confirmed,
      }),
    },
  })

  return methods
}
